import genericmodel from "../genericmodel.interface";
import ISessao from "../sessao/sessao.interface";

export enum Status {
  Recusado,
  Aprovado,
  Pendente
}

export default interface IAgendamento extends genericmodel{
  status: Status,
  nome:string;
  email:string;
  telefone:string;
  sessaoEscolhida:ISessao|undefined;
  sessaoEscolhidaId:number;
  dataHoraSessao:string;
  instituicao:string;
  municipio:string;
  serie:string;
  alunos:number;
  professor:string;
  emailProfessor:string;
  tipoEscola:string;
  telefoneEscola:string;
  telefoneProfessor:string;
  alunoDeficiente:string;
  virtual:boolean;
}

